// 居宅訪問API.
import axios, { AxiosInstance } from 'axios';
import { Dispatch } from 'redux';
import * as Moff from '../constants/MoffAPI';
import * as AWS from '../constants/AWS';

export class HomeVisitAPI {
  /** インスタンス */
  private static _instance: HomeVisitAPI;
  private axiosInstance: AxiosInstance;

  /** インスタンスの取得 */
  public static get instance(): HomeVisitAPI | null {
    // _inctanceが存在しない場合に、new User()を実行する。
    if (!this._instance) {
      this._instance = new HomeVisitAPI();
      
      // .envの設定 
      const API_BASE_URL = String(process.env.REACT_APP_HOME_VISIT_API_URL);
      const API_KEY = String(process.env.REACT_APP_HOME_VISIT_API_KEY);
      if (typeof API_BASE_URL === 'undefined') {
        alert('.envにREACT_APP_HOME_VISIT_API_URLの設定がありません.');
        return null;
      }

      if (typeof API_KEY === 'undefined') {
        alert('.envにREACT_APP_HOME_VISIT_API_KEYの設定がありません.');
        return null;
      }

      const userPool = AWS.userPool();
      const cognitoUser = userPool.getCurrentUser();
      if (cognitoUser === null) {
        return null;
      }

      const self = this;
      cognitoUser.getSession(function(err: any, session: any) {
        if (err) {
          return;
        }

        if (session) {
          self._instance.axiosInstance = axios.create({
            baseURL: API_BASE_URL,
            headers: {
              'Authorization': session.getIdToken().getJwtToken(),
              'x-api-key': API_KEY
            }
          });
        }
      });
    }

    // 生成済みのインスタンスを返す
    return this._instance;
  }

  // 件数取得.
  public getRecordCount(
    uniqueId: string, requestFunc: Function, fetchedFunc: Function): any {
    const self = this;
    const url = `/homevisit/users/${uniqueId}/records`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.get(url)
        .then(function(response: any) {
          dispatch(fetchedFunc(Moff.SUCCESS, response.data));
        })
        .catch(function(error: any) {
          self.showAxiosError('getRecordCount', error);
          dispatch(fetchedFunc(Moff.ERROR, error));
        });
    };
  }

  // 指定の1件を取得.
  public getRecord(
    uniqueId: string, sequence: number, requestFunc: Function, fetchedFunc: Function): any {
    const self = this;
    const url = `/homevisit/users/${uniqueId}/records/${sequence}`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.get(url)
        .then(function(response: any) {
          dispatch(fetchedFunc(Moff.SUCCESS, response.data));
        })
        .catch(function(error: any) {
          self.showAxiosError('getRecord', error);
          dispatch(fetchedFunc(Moff.ERROR, error));
        });
    };
  }

  // エラーポップアップ.
  // apiNameはどのAPIによるものか.
  private showAxiosError(apiName: string, error: any) {
    if (error.toString().indexOf('Network Error') !== -1) {
      const errorMessage = '通信エラーが発生しました。インターネット接続が出来ることを確認してから再度ページを読み込み直して下さい。';
      alert(errorMessage);
    } else if (error.toString().indexOf('timeout') !== -1) {
      const errorMessage = '通信エラーが発生しました。インターネット接続が良好な環境で、再度ページを読み込み直して下さい。';
      alert(errorMessage);
    }

    // ログインへ.
    // window.location.href = '/';
  }
}



// WEBPACK FOOTER //
// ./src/api/HomeVisit.tsx